import Icon, { AvailableIcons } from '$store/components/ui/Icon.tsx'
import { useEffect, useState } from 'preact/hooks'

const colsQuantityArray = [3, 4] as const

type ColsQuantity = typeof colsQuantityArray[number]

const ICON_MAP: Record<ColsQuantity, AvailableIcons> = {
    '3': 'Vertical3Bars',
    '4': 'Vertical4Bars',
}

export default function GallerySwitcher() {
    const [colsQuantity, setColsQuantity] = useState<ColsQuantity>(3)

    useEffect(() => {
        const colsQuantityStorage = localStorage.getItem('cols-quantity')
        if (colsQuantityStorage) {
            setColsQuantity(parseInt(colsQuantityStorage) as ColsQuantity)
        }
    }, [])

    useEffect(() => {
        const $listGallery = document.querySelectorAll<HTMLElement>('.search-result-gallery')

        if (!$listGallery) return

        $listGallery.forEach(($gallery) => {
            $gallery.dataset.colsLayout = `cols-${colsQuantity}`
        })
    }, [colsQuantity])

    return (
        <div class='items-center gap-2 hidden lg:flex'>
            {colsQuantityArray.map((quantity) => {
                return (
                    <button
                        data-active={colsQuantity === quantity}
                        class='group cursor-pointer'
                        onClick={(e) => {
                            setColsQuantity(quantity)
                            localStorage.setItem('cols-quantity', `${quantity}`)
                        }}
                    >
                        <Icon
                            id={ICON_MAP[quantity]}
                            width={30}
                            height={20}
                            class='text-neutral-3 group-data-[active="true"]:text-neutral-1 transition-all duration-300'
                        />
                    </button>
                )
            })}
        </div>
    )
}
